// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors

const FUNCTION_IDENTIFIER = '@@=';
const CONSTANT_IDENTIFIER = '@@#';
const TYPE_KEY = '@@type';
const FUNCTION_KEY = '@@function';

export {FUNCTION_IDENTIFIER, CONSTANT_IDENTIFIER, TYPE_KEY, FUNCTION_KEY};
